import mpApi from "@/platform/mp";
import webApi from "@/platform/web";
var platformApi = true ? webApi : mpApi;
export default platformApi;
